/**
 * The ONLY document types with the in-app "Approve & Lock Document" flow.
 *
 * Single source for web (`lib/documents/approvals.ts` re-exports it), the
 * approve routes and the mobile app. The app uses it as the fallback when a
 * server that predates the `canApprove` wire field sends none, so an old server
 * and a new app can never disagree about which types are approvable.
 */
export const IN_APP_APPROVABLE_DOCUMENT_TYPES = [
  "SITE_INDUCTION",
  "EMERGENCY_PLAN",
] as const;

export function canApproveInApp(documentType: string): boolean {
  return (IN_APP_APPROVABLE_DOCUMENT_TYPES as readonly string[]).includes(
    documentType,
  );
}
